import { Controller } from "@hotwired/stimulus";

// One-shot resync of a single adapter row whenever the Action Cable
// subscription is (re)confirmed. Fires after the WS handshake completes —
// catches up state that may have been broadcast before subscription was
// confirmed (e.g. user clicked Start before Cloudflare finished the cable
// handshake) and after any later disconnect/reconnect.
export default class extends Controller {
  static values = { url: String };

  connect() {
    const accordion = this.element.closest("tbody[data-controller]");
    if (accordion && accordion.dataset.controller.includes("accordion")) {
      this.element.dataset.accordionTarget = "panel";
      if (!accordion.hasAttribute("data-open")) {
        this.element.classList.add("hidden");
      }
    }
    // Scoped to this page's own stream source so an unrelated stream (e.g. the
    // notifications bell, also present via the shared layout) reconnecting
    // doesn't trigger a redundant resync + aborted fetch for every row.
    this.streamSource = document.getElementById("system-admin-adapters-stream");
    this.streamSource?.addEventListener("turbo:cable-connected", this.onCableConnected);
  }

  disconnect() {
    this.streamSource?.removeEventListener("turbo:cable-connected", this.onCableConnected);
    this.controller?.abort();
  }

  onCableConnected = () => this.resync();

  async resync() {
    this.controller?.abort();
    this.controller = new AbortController();

    try {
      const res = await fetch(this.urlValue, {
        headers: { Accept: "text/vnd.turbo-stream.html" },
        credentials: "same-origin",
        signal: this.controller.signal,
      });
      if (!res.ok) return;
      const stream = await res.text();
      window.Turbo?.renderStreamMessage(stream);
    } catch {
      // aborted or network blip — next cable-connected will retry
    }
  }
}
